import demoimage from "../Images/image.webp";

export default function SectionComp({ title, para }) {
  return (
    <div className="new-home-wedding-category-section-head-main-con sectionTitle">
      <div className="all-page-common-head-main-section">
        <div className="head-common-image-con">
          <img src={demoimage} />
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <div className="all-page-common-tag-para-main-con text-center">
            <h3>{title}</h3>
            <p>{para}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
